<template>
  <div class="myOrder">
    <div class="top">
      <div class="tabList">
        <div
          class="item"
          @click="onTab(v, i)"
          :class="{ active: i == tabI }"
          v-for="(v, i) in orderTab"
          :key="v.name"
        >
          {{ v.name }}
        </div>
      </div>

      <div class="title">我的订单</div>
    </div>

    <div class="Box" v-loading="loading">
      <div class="content">
        <div class="list" v-for="(v, i) in orderList" :key="i">
          <div class="top">
            <div class="top-left" @click="copyClick(v.orderNo)">
              <div class="orderNo">订单编号：{{ v.orderNo }}</div>
            </div>
            <div
              :class="[
                'top-right',
                v.payStatusText == '待付款'
                  ? 'wait'
                  : v.payStatusText == '已完成'
                  ? 'finish'
                  : v.payStatusText == '已取消'
                  ? 'cancel'
                  : v.payStatusText == '已退款'
                  ? 'refund'
                  : ' ',
              ]"
            >
              {{ v.payStatusText }}
            </div>
          </div>

          <div class="center">
            <div class="center-right">
              <div class="title">
                <span style="max-width: 100%">{{ v.productSubject }}</span>
              </div>
              <div>
                <span class="label_box" style="font-size: 12px">
                  {{ examineType(v) }}
                </span>
              </div>
              <div style="display: flex; align-items: center">
                <div class="price">
                  {{ v.orderType !== 6 ? '￥' : '' }}
                  <span>
                    {{ v.orderPrice }}
                  </span>
                  {{ v.orderType === 6 ? '字符' : '' }}
                </div>
                <div class="total">{{ v.createTime }}</div>
              </div>
            </div>
          </div>

          <div class="bottom">
            <div class="time"></div>
            <div class="btn-box">
              <div
                class="btn wait"
                v-if="v.orderStatus == 0"
                @click="writerAcceptOrder(v)"
              >
                撤销订单
              </div>
              <!-- <div
								class="btn wait"
								v-if="v.orderStatus == 9 &&v.payStatus == 2 && !v.comment &&v.orderType !== 8"
								@click="goComment(v)"
							>评论</div>
							<div
								class="btn wait"
								v-if="!v.execute &&(v.payStatus == 2 || v.payStatus == 7) &&(v.orderType == 9 || v.orderType == 10) &&v.orderType !== 8 &&!v.url"
								@click="goGenerate(v)"
							>
								继续生成
							</div> -->
              <div class="btn" @click="goDetails(v.orderId)">订单详情</div>
              <div class="btn1" @click="adds(v, i)" v-if="v.writer && v.isShow">
                提交验收
              </div>
              <div class="btn1" @click="add(v, i)" v-if="!v.writer && v.isShow">
                验收完成
              </div>

              <!-- <div class="btn pay"
											v-if="v.payStatus== 2 && v.orderStatus == 8 && v.orderType !== 8"
											@click="writerAcceptOrder(v,4)">
											确认完成
										</div> -->
              <div
                class="btn pay"
                v-if="v.payStatusText === '待付款'"
                @click="orderPayment(v)"
              >
                立即支付
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="kong" v-if="orderList.length == 0">
        <img :src="$store.state.wqurl + 'all_page_nullTowImg.png'" alt="" />

        暂无数据
      </div>
    </div>
    <div class="pagination">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 扫码支付 -->
    <el-dialog
      title="扫码支付"
      :visible.sync="payVisible"
      @close="onClose"
      class="payment"
    >
      <div class="content">
        <div class="notes">请使用微信扫码下方二维码完成支付</div>
        <div class="imgBox">
          <img :src="payimg" alt="" />
        </div>
      </div>
    </el-dialog>

    <orderDetails v-if="orderId" @back="orderId = ''" :orderId="orderId" />
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  orderPageList,
  orderPayment,
  cancelOrder,
  payOrderQuery,
} from '@/api/professionServer'
import orderDetails from './orderDetails'
import qs from 'qs'
export default {
  name: 'myOrder',
  //import引入的组件需要注入到对象中才能使用
  components: { orderDetails },
  data() {
    //这里存放数据
    return {
      tabI: 0,
      orderTab: [
        {
          name: '全部',
          status: '',
        },
        {
          name: '待付款',
          status: 1,
        },
        {
          name: '待收货',
          status: 3,
        },
        {
          name: '待评价',
          status: 6,
        },
        {
          name: '已撤销',
          status: 5,
        },
        {
          name: '已完成',
          status: 2,
        },
      ],
      orderList: [],
      page: 1,
      total: 0,
      // 支付弹框
      payVisible: false,
      // 支付扫码图片
      payimg: '',
      // 查询定时器
      timer: null,
      loading: false,
      // 订单id
      orderId: '',
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    onTab(value, index) {
      this.tabI = index

      this.getList(value)
    },

    async getList(val = {}, reset = true) {
      try {
        this.loading = true
        if (reset) {
          this.page = 1
          this.orderList = []
        }
        const data = {
          limit: 20,
          page: this.page,
          writer: false,
          status: val.status,
          keyword: '',
        }

        const res = await orderPageList(data)
        this.loading = false
        if (res.code == 200) {
          let dat = []
          res.data.data.forEach((item) => {
            dat.push(false)
          })
          console.log(dat)
          if (!localStorage.getItem('datValue')) {
            localStorage.setItem('datValue', JSON.stringify(dat))
          }
          res.data.data.forEach((item, i) => {
            item.isShow = !JSON.parse(localStorage.getItem('datValue'))[i]
          })
          this.orderList = res.data.data
          this.total = res.data.total
        }
      } catch (error) {
        this.loading = false
      }
    },

    // 判断是那种订单
    examineType(item) {
      if (!item.orderType) {
        return '暂无类型'
      }

      if (item.orderType === 7) {
        if (item.resultType === 1) {
          return '统计分析'
        } else {
          return 'AI成文'
        }
      } else if (item.orderType === 6) {
        return 'AIGC模型'
      } else if (item.orderType === 8) {
        return '专业服务'
      } else {
        return item.tag || '暂无类型'
      }
    },

    // 撤销订单
    writerAcceptOrder(v) {
      this.$confirm('撤销订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await cancelOrder(qs.stringify({ orderId: v.orderId }))
          this.orderList = []
          this.getList(this.orderTab[this.tabI], false)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },

    // 支付
    async orderPayment(v) {
      const data = {
        applicationTpye: this.$store.state.publicType,
        openId: '',
        orderId: v.orderId,
        wayCode: 'WX_NATIVE',
      }

      const res = await orderPayment(data)

      if (res.code !== 200) return
      this.payimg = res.data.payData
      this.payVisible = true

      this.timer = setInterval(() => {
        this.payOrderQuery(res.data.payOrderId)
      }, 3000)
    },

    // 订单支付状态查询
    async payOrderQuery(id) {
      let res = await payOrderQuery({
        payOrderId: id,
      })

      if (res.code !== 200) return
      clearInterval(this.timer)
      this.timer = null
      this.payVisible = false
      this.$message.success('支付成功')
      this.orderList = []
      this.getList(this.orderTab[this.tabI], false)
    },

    onClose() {
      clearInterval(this.timer)
      this.timer = null
    },

    // 分页
    handleCurrentChange(v) {
      this.page = v
      this.orderList = []

      this.getList({}, false)
    },
    adds(v, i) {
      let list = JSON.parse(localStorage.getItem('datValue'))
      if (list[i] == true) {
        v.isShow = false
        this.$message.error('您已提交验收，请勿重复提交')
        return
      }
      this.$confirm('您确定要提交验收吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          list[i] = true

          localStorage.setItem('datValue', JSON.stringify(list))
          v.isShow = false
          this.$message({
            type: 'success',
            message: '提交成功!',
          })
        })
        .catch(() => {})
    },
    add(v, i) {
      let list = JSON.parse(localStorage.getItem('datValue'))
      if (list[i] == true) {
        this.$message.error('您已验收完成，请勿重复确认')
        return
      }
      this.$confirm('您确定要验收完成吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          list[i] = true
          localStorage.setItem('datValue', JSON.stringify(list))
          v.isShow = false
          this.$message({
            type: 'success',
            message: '验收成功!',
          })
        })
        .catch(() => {})
    },
    // 订单详情
    goDetails(id) {
      this.orderId = id
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getList()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
.myOrder {
  height: 100%;
  position: relative;
  .top {
    display: flex;
    align-items: center;
    padding: 15px;
    height: 60px;
    box-sizing: border-box;
    border-bottom: 1px solid #eaeaea;
    justify-content: space-between;
    .title {
      font-weight: bold;
      font-size: 16px;
    }
    .tabList {
      display: flex;
      align-items: center;
      font-size: 15px;
      gap: 20px;
      .item {
        cursor: pointer;
        padding: 10px;
        border-radius: 5px;

        &:hover {
          background: #edf2ff;
          color: #326afb;
        }
      }

      .active {
        background: #edf2ff;
        color: #326afb;
      }
    }
  }

  .Box {
    height: calc(100% - 100px);
    overflow: auto;

    .content {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      padding: 15px;
      gap: 15px 0;
      .list {
        border: 1px #eaeaea solid;
        width: 49%;
        border-radius: 10px;
        .top {
          padding-bottom: 15px;
          box-sizing: border-box;
          display: flex;
          align-items: flex-start;
          flex-direction: column;
          gap: 8px;
          border-bottom: 1px #eaeaea solid;

          .top-left {
            font-size: 14px;
            color: #999;
            display: flex;
            align-items: center;

            .copy {
              width: 10px;
              height: 10px;
              margin-left: 5px;
            }
          }

          .top-right {
            font-size: 14px;
            color: #4587ff;
          }
        }
        .center {
          .center-right {
            padding: 15px;
            display: flex;
            flex-direction: column;
            gap: 15px 0;

            .title {
              font-size: 17px;
              color: #333;
              font-weight: bold;
              display: flex;
              align-items: center;
            }

            .label_box {
              padding: 1px 5px;
              border: #b2c6fb solid 1px;
              box-sizing: border-box;
              background-color: #dce6ff;
              border-radius: 3px;
              color: #587ad4;
            }

            .total {
              font-size: 12px;
              color: #999;
            }

            .price {
              margin-right: 10px;
              font-size: 12px;
              color: #eb441e;
              font-weight: 500;

              .totalHours {
                color: #999;
                font-size: 12px;
              }

              > span {
                font-size: 16px;
              }
            }
          }
        }

        .bottom {
          margin-top: 10px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .time {
            font-size: 12px;
            color: #999;
          }

          .btn-box {
            display: flex;
            padding: 15px;

            .btn {
              cursor: pointer;
              height: 30px;
              padding: 0 15px;
              margin-left: 12px;
              line-height: 30px;
              border-radius: 15px;
              color: #333;
              border: 1px solid #f3f4f5;
              font-size: 13px;
            }
            .btn1 {
              cursor: pointer;
              height: 30px;
              padding: 0 15px;
              margin-left: 12px;
              line-height: 30px;
              border-radius: 15px;
              color: #333;
              color: #fff;
              background-color: #326afb;
              font-size: 13px;
            }
            .pay {
              color: #fff;
              border: none;
              background-color: #00b569;
            }
          }
        }
      }
    }

    .kong {
      display: flex;
      align-items: center;
      flex-direction: column;
      font-size: 14px;
      gap: 10px;
      color: #a6a9b1;
      justify-content: center;
      height: calc(100% - 30px);
      width: 100%;

      img {
        width: 110px;
      }
    }
  }

  // 支付弹窗
  .payment {
    ::v-deep .el-dialog {
      top: 50%;
      transform: translateY(-50%);
      margin-top: 0 !important;
      width: 500px;
      height: 390px;
      background: #ffffff;
      border: 0px solid #818790;
      box-shadow: 0px 0px 16px 0px rgba(98, 102, 107, 0.2);
      .el-dialog__header {
        height: 42px;
        background: #f4f6f7;
        padding: 0;
        line-height: 42px;
        .el-dialog__title {
          margin-left: 15px;
          font-size: $font-size-medium;
          font-family: PingFang SC;
          font-weight: 500;
          color: #393939;
        }
        .el-dialog__headerbtn {
          top: $font-size-small;
          right: $font-size-small;
          font-size: $font-size-large;
        }
      }
      .el-dialog__body {
        padding: 65px 20px;
        .content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .notes {
            font-size: $font-size-medium;
            font-family: PingFang SC;
            font-weight: 500;
            color: $color-text-black;
          }
          .imgBox {
            width: 110px;
            height: 110px;
            margin-top: 30px;
            img {
              width: 110px;
              height: 110px;
            }
          }
        }
      }
    }
  }

  .pagination {
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: center;
  }

  .wait {
    color: #4587ff !important;
  }

  .finish {
    color: #00b569 !important;
  }

  .cancel {
    color: #999999 !important;
  }

  .refund {
    color: #ff6500 !important;
  }

  .online {
    color: #00b569 !important;
    background-color: #edf6f2 !important;
  }

  .offline {
    color: #4587ff !important;
    background-color: #ecf3ff !important;
  }
}
</style>
